import { jsxs as o, jsx as e } from "react/jsx-runtime";
import { NextgenDOMPurify as n } from "@nextgen-web-framework/all";
import r from "../AudioPlayer/AudioPlayer.js";
import '../../assets/ContentHeaderCard.css';const l = "#ffffff", c = "#396e75", s = "#e5fdff", f = "#546223", _ = "#f0fae5", g = "#a65523", z = "#fff1e8", h = "#7f3e3e", V = "#ffe2e2", u = "#62625a", C = "#f8f8e7", y = "#38539a", k = "#707070", m = "#c8f8d1", B = "#87c9c8", v = "#5291b1", b = "rgba(82, 145, 177, 0.1019607843)", q = "#445685", N = "#181d61", O = "rgba(24, 29, 97, 0.1019607843)", G = "#5969d6", w = "#ea999d", R = "#b6577e", W = "rgba(182, 87, 126, 0.1019607843)", x = "#7e3e80", P = "#1e247f", T = "rgba(30, 36, 127, 0.1019607843)", Y = "#da7600", A = "#107f47", S = "#d91734", j = "_html_q6ypf_38", F = "_content_q6ypf_72", H = "_header_q6ypf_76", M = "_tag_q6ypf_76", D = "_title_q6ypf_82", I = "_footer_q6ypf_88", L = "_description_q6ypf_97", $ = "_audio_player_q6ypf_104", t = {
  amwayWhite: l,
  darkBlue: c,
  lightBlue: s,
  darkGreen: f,
  lightGreen: _,
  darkOrange: g,
  lightOrange: z,
  darkRed: h,
  lightRed: V,
  darkYellow: u,
  lightYellow: C,
  darkPurple: y,
  darkGrayOnWhite: k,
  dataVizColor1: m,
  dataVizColor2: B,
  dataVizColor3: v,
  dataVizColor3Background: b,
  dataVizColor4: q,
  dataVizColor5: N,
  dataVizColor5Background: O,
  dataVizColor6: G,
  dataVizColor7: w,
  dataVizColor8: R,
  dataVizColor8Background: W,
  dataVizColor9: x,
  dataVizColor10: P,
  dataVizColor10Background: T,
  dataVizAlertOrange: Y,
  dataVizSuccessGreen: A,
  dataVizWarningRed: S,
  "no-visible": "_no-visible_q6ypf_34",
  html: j,
  "content-header-card-container": "_content-header-card-container_q6ypf_72",
  content: F,
  header: H,
  tag: M,
  title: D,
  footer: I,
  description: L,
  audio_player: $
}, Q = (a) => {
  var i, d;
  return /* @__PURE__ */ o("div", { className: `${t["content-header-card-container"]}`, "data-testid": "content-header-card-container-testid", children: [
    /* @__PURE__ */ o("div", { className: t.content, children: [
      /* @__PURE__ */ o("div", { className: t.header, children: [
        /* @__PURE__ */ e("div", { className: t.tag, children: a.tag }),
        a.title && /* @__PURE__ */ e("div", { className: t.title, title: a.title, children: a.title })
      ] }),
      a.subTitle && /* @__PURE__ */ o("div", { className: t.footer, children: [
        " ",
        /* @__PURE__ */ e("div", { className: t["footer-line"], children: a.subTitle })
      ] }),
      a.description && /* @__PURE__ */ e(
        "div",
        {
          className: t.description,
          dangerouslySetInnerHTML: {
            __html: a.sanitize ? n(a.description ?? "", a.sanitizationConfig) : a.description
          }
        }
      )
    ] }),
    ((i = a == null ? void 0 : a.audioFile) == null ? void 0 : i.audio_file.url) && /* @__PURE__ */ e("div", { className: t.audio_player, children: /* @__PURE__ */ e(r, { audio_file: (d = a == null ? void 0 : a.audioFile) == null ? void 0 : d.audio_file, componentType: "audio_player" }) })
  ] });
};
export {
  Q as default
};
//# sourceMappingURL=ContentHeaderCard.js.map
